<template>
  <div :class="$style.Container">
    <Avatar
      :radius="isPersonal ? '50%' : '6px'"
      :able-select="false"
      :size="props.avatarSize"
      :src="url"
    />
    <div :class="$style.Right">
      <div :class="[$style.Title, props.isVip ? $style.TitleLight : null]">{{ props.title }}</div>
      <div :class="$style.Des">
        <div :class="$style.LingdouInfo" v-if="props.showLingdou">
          <Lingdou :size="12" light :class="$style.Lingdou" />
          可用灵豆：{{ props.lingdouNum }}
        </div>
        <div :class="$style.Line" v-if="props.showLingdou && props.showStorage"></div>
        <div :class="$style.StorageInfo" v-if="props.showStorage">
          <img
            style="width: 12px; height: 12px; margin-right: 2px"
            src="https://static.lingvisions.com/public/4e4f8c0751c14b7d82537fb6f45e1aac.png"
            alt="icon"
          />
          可用图片存储容量：{{ commerceStore.storageInfo?.remain }}GB
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { Avatar } from '@lingtu/components';
  import { computed } from 'vue';
  import Lingdou from './lingdou.vue';
  import { useCommerceStoreWithOut } from '/@/store/modules/commerce';

  const DEFAULT_PERSONAL_AVATAR_URL =
    'https://static.lingvisions.com/public/4f8bd9027e1042c58418d5f916af0158.png';

  const DEFAULT_TEAM_AVATAR_URL =
    'https://static.lingvisions.com/public/be66e028a7eb4c298a5c03dfbcfa4914.png';

  const props = defineProps({
    avatarUrl: {
      type: String,
      default: '',
    },

    title: {
      type: String,
      default: '',
    },

    lingdouNum: {
      type: Number,
      default: 0,
    },

    avatarSize: {
      type: Number,
      default: 62,
    },

    isVip: {
      type: Boolean,
      default: false,
    },

    expireTime: {
      type: String,
      default: '',
    },

    isPersonal: {
      type: Boolean,
      default: false,
    },

    showLingdou: {
      type: Boolean,
      default: true,
    },

    showStorage: {
      type: Boolean,
      default: true,
    },

    showVip: {
      type: Boolean,
      default: true,
    },
  });

  const commerceStore = useCommerceStoreWithOut();

  const url = computed(() => {
    if (props.avatarUrl) {
      return props.avatarUrl;
    }

    return props.isPersonal ? DEFAULT_PERSONAL_AVATAR_URL : DEFAULT_TEAM_AVATAR_URL;
  });
</script>

<style lang="less" module>
  .Container {
    display: flex;
    align-items: center;
  }

  .Right {
    margin-left: 12px;
  }

  .Title {
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    color: rgba(255, 255, 255, 0.85);
    max-width: 64vw;
  }

  .TitleLight {
    color: rgba(255, 177, 27, 1);
  }

  .Line {
    background-color: #424242;
    height: 12px;
    width: 1px;
    margin: 0 8px;
  }

  .Des {
    display: flex;
    align-items: center;
    margin-top: 4px;
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    color: rgba(255, 255, 255, 0.65);

    > div {
      display: flex;
      align-items: center;
    }
  }

  .ExpireTime {
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    color: #936d22;
    margin-left: 4px;
  }

  .LingdouInfo {
    color: rgba(255, 255, 255, 0.85);
  }

  .StorageInfo {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: var(--colorTextSecondary, rgba(255, 255, 255, 0.65));
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
  }

  .Lingdou {
    margin-right: 4px;
  }

  @media (max-width: 500px) {
    .Des {
      flex-direction: column;
      align-items: flex-start;
    }

    .Line {
      display: none !important;
    }

    .LingdouInfo {
      margin-top: 4px;
    }

    .Lingdou {
      display: none;
    }
  }
</style>
